<template>
  <div id="content" class="project_space">
    <ProjectNameModal :dialogVisible='dialog' @close="dialog=false" @newValueIsProposed="setNewProjectName($event)" formName="Update project name" :projectName="project.name" ></ProjectNameModal>
    <ProjectNameModal :dialogVisible='dialogSF' @close="closeSFModal" @newValueIsProposed="setNewSFtName($event)" formName="Update searchfield name" :projectName="currentSearchField.name" ></ProjectNameModal>

    <div class="container">

      <div class="project_searchfield_dash"  v-for="(sf, s) in project.search_field" :key="s"  :id="sf._id.$oid">
        <div class="row">
            <div class="col-12 text-center dotted_border_bottom">
              <span class="project_name">{{project.name}}   <v-btn variant="outlined" size="x-small" icon="mdi-pencil" @click="dialog = true"></v-btn></span>
              <span class="searchfield_name">{{sf.name}}  <v-btn variant="outlined" size="x-small" icon="mdi-pencil" @click="sfModal(sf)"></v-btn> </span>

              <div v-if="project.isOpen == false" class="alert alert-danger" style="margin-top:10px;">Closed</div>
            </div>
        </div>

          <div class="row  actionsOnePro" v-if="project.isOpen != false">
              <div class="col-12 col-lg-6">
                  <span class="action_title">Customer's actions</span>
                  <div>
                    <div class="action_list" :class="(project.business_challenge) ? 'done' : ''" v-if="project.challenges.business_challenge">
                      <div class="name">
                          <router-link :to="'/expert/business_challenge/'+project._id.$oid">
                            <span>{{$t('Define business challenge')}}</span>
                            <img :src="require('@/assets/action_go_to.svg')" alt="">
                          </router-link>
                      </div>

                    </div>

                    <div class="action_list done" :class="(project.scouting_challenge) ? 'done' : ''" v-if="project.challenges.scouting_challenge">
                      <div class="name"  v-if="sf.scouting_challenge">
                        <router-link :to="'/expert/scouting_brief_complete/'+sf._id.$oid+'/'+project._id.$oid" >
                            <span>{{$t('Validate scouting brief')}}</span>
                            <img :src="require('@/assets/action_go_to.svg')" alt="">
                          </router-link>

                      </div>
                      <div class="name" v-else>
                          <span>{{$t('Define scouting criteria')}} </span>
                      </div>
                    </div>
                      <div class="action_list done" :class="(sf.longList.length) ? 'done' : ''" v-if="sf.longList.length || sf.candidatesPools.length">
                        <div class="name">
                          <router-link :to="'/expert/candidatespool/'+sf._id.$oid+'/'+project._id.$oid">
                            <span>{{$t('Qualify innovators')}}</span>
                                <img :src="require('@/assets/action_go_to.svg')" alt="">
                              </router-link>
                        </div>
                      </div>
                      <div class="action_list" v-else-if="project.challenges.scouting_challenge">
                        <div class="name">
                            <span>{{$t('Qualify innovators')}} </span>
                        </div>
                      </div>



                    <div class="" v-if="project.challenges.assessment_challenge">
                                          <div class="action_list" :class="(sf.assessments) ? 'done' : ''" v-if="sf.assessments.length">
                                            <div class="name">
                                              <router-link :to="'/expert/manage_assessments?project='+project._id.$oid">
                                                <span>{{$t("Assess innovators")}}</span>
                                                    <img :src="require('@/assets/action_go_to.svg')" alt="">
                                                  </router-link>
                                            </div>

                                          </div>
                                          <div class="action_list" v-else>
                                            <div class="name">
                                              <span>{{$t('Assess innovators')}} </span>
                                            </div>
                                          </div>
                  </div>



                                      <div class="action_list" :class="(sf.assessmentsResults) ? 'done' : ''" v-if="sf.assessmentsResults.length">
                                        <div class="name" >
                                              <router-link :to="'/expert/manage_assessments?project='+project._id.$oid">
                                            <span>{{$t('Shortlist potential partners')}}</span>
                                                <img :src="require('@/assets/action_go_to.svg')" alt="">
                                              </router-link>
                                        </div>

                                      </div>
                                      <div class="action_list" v-else>
                                        <div class="name">
                                                  <span>{{$t('Shortlist potential partners')}}</span>
                                        </div>
                                      </div>

                    <!-- <div :class="'action_list '+task.status" v-if="(sf.seeAllStep != true && (task.status == 'required' || task.isNew == true) ) || sf.seeAllStep == true">
                      <div class="name">
                        <router-link :to="'/expert/business_challenge/'+project._id.$oid" v-if="task.status == 'done' && task.task_code == 'business_challenge' && sf.seeAllStep">
                          Define customer’s brief

                          <v-badge v-if="task.status == 'done'" color="#288237" content="DONE" inline></v-badge>
                        </router-link>
                        <router-link :to="'/expert/scouting_brief_complete/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.status == 'done'&& task.task_code == 'scouting_brief' && sf.seeAllStep">{{task.task_name}}
                            <v-badge v-if="task.status == 'done'" color="#288237" content="DONE" inline></v-badge>
                        </router-link>

                        <router-link :to="'/expert/candidatespool/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.status == 'done' && task.task_code == 'assessment_definition' && sf.seeAllStep">{{task.task_name}}
                           <v-badge v-if="task.status == 'done'" color="#288237" content="DONE" inline></v-badge>
                         </router-link>
                        <router-link :to="'/expert/manage_assessments/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.status == 'done'&& task.task_code == 'assessment' && sf.seeAllStep">{{task.task_name}}
                          <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                          <v-badge v-if="task.status == 'done'" color="#288237" content="DONE" inline></v-badge>
                        </router-link>


                        <span v-else>{{task.task_name}}
                          <v-badge color="#6C68A2" content="IN PROGRESS" inline v-if="task.status == 'required'"></v-badge>

                        </span>
                      </div>
                    </div> -->
                </div>
              </div>
              <div class="col-12 col-lg-6">
                  <span class="action_title">Innopearl Deliverables</span>
                  <div class="">
                    <div class=""  v-if="project.challenges.business_challenge">
                      <div class="action_list" :class="(project.business_challenge_sharped) ? 'done' : ''" v-if="project.business_challenge.isSubmit">
                        <div class="name">
                            <router-link :to="'/expert/business_challenge/'+project._id.$oid">
                              <span>{{$t('Targeted business brief')}}</span>
                                    <img :src="require('@/assets/action_go_to.svg')" alt="">
                            </router-link>
                        </div>

                      </div>
                      <div class="action_list" v-else>
                        <div class="name">
                          {{$t('Targeted business brief')}}
                        </div>
                      </div>

                    </div>

                    <div class="" v-if="project.challenges.scouting_challenge">

                      <div class="action_list "  :class="(sf.scouting_challenge.scouting_brief.isAdminSubmit) ? 'done' : ''" v-if="sf.scouting_challenge.scouting_brief">
                        <div class="name">
                          <router-link :to="'/expert/scouting_brief/'+sf._id.$oid+'/'+project._id.$oid">
                            <span>{{$t('Scouting brief')}}</span>
                                  <img :src="require('@/assets/action_go_to.svg')" alt="">
                          </router-link>
                        </div>
                      </div>
                <div class="action_list "  v-else>
                  <div class="name">
                    {{$t('Scouting brief')}}
                  </div>
                </div>

                <div class="action_list" :class="(sf.assessments) ? 'done' : ''" >
                  <div class="name">
                    <router-link :to="'/expert/candidatespool/'+sf._id.$oid+'/'+project._id.$oid" >
                      <span>{{$t("Candidates pools")}}</span>      <img :src="require('@/assets/action_go_to.svg')" alt=""></router-link>
                  </div>

                </div>

                    </div>



                    <div class="" v-if="project.challenges.assessment_challenge">
                      <div class="action_list" :class="(sf.assessments.length) ? 'done' : ''" >
                        <div class="name">
                          <router-link :to="'/expert/manage_assessments?project='+project._id.$oid" ><span>{{$t("Selected innovators")}}</span>
                                <img :src="require('@/assets/action_go_to.svg')" alt=""></router-link>
                        </div>

                      </div>

                      <div class="action_list" :class="(sf.assessmentsResults.length) ? 'done' : ''">
                            <div class="name" >
                                <router-link :to="'/expert/manage_assessments?project='+project._id.$oid"><span>{{$t('Assessment results')}}</span>
                                      <img :src="require('@/assets/action_go_to.svg')" alt=""></router-link>
                            </div>
                      </div>

                    </div>
                  </div>
                  <!-- <div v-for="(task, t) in sf.innopearl_tasks" :key="t"  class="" style="margin-top:5px;margin-bottom:5px;">
                    <div :class="'action_list '+task.status" v-if="(sf.seeAllStep != true && (task.status == 'required' || task.isNew == true) ) || sf.seeAllStep == true">
                      <div class="name">
                    <router-link :to="'/expert/business_challenge/'+project._id.$oid" v-if="task.task_code == 'business_challenge' && ((task.status == 'required' ) || (task.status == 'done' &&  sf.seeAllStep))">
                      {{task.task_name}}
                      <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                        <v-badge v-if="task.status == 'done'" color="#39933f" content="done" inline></v-badge>
                    </router-link>
                    <router-link :to="'/expert/scouting_brief/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.task_code == 'scouting_brief' && ((task.status == 'required' ) || (task.status == 'done' &&  sf.seeAllStep))">
                      {{task.task_name}}
                      <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                        <v-badge v-if="task.status == 'done'" color="#39933f" content="done" inline></v-badge>
                    </router-link>
                    <router-link :to="'/expert/candidatespool/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.task_code == 'assessment_definition' && ((task.status == 'required' ) || (task.status == 'done' &&  sf.seeAllStep))">
                      {{task.task_name}}
                      <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                        <v-badge v-if="task.status == 'done'" color="#39933f" content="done" inline></v-badge>
                    </router-link>
                    <router-link :to="'/expert/manage_assessments/'+sf._id.$oid+'/'+project._id.$oid" v-else-if="task.task_code == 'assessment' && ((task.status == 'required' ) || (task.status == 'done' &&  sf.seeAllStep))" >
                      {{task.task_name}}
                      <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                        <v-badge v-if="task.status == 'done'" color="#39933f" content="done" inline></v-badge>
                    </router-link>
                    <span v-else>{{task.task_name}}   <v-badge v-if="task.status == 'required'" color="#C63221" content="REQUIRED" inline></v-badge>
                      <v-badge v-if="task.status == 'done'" color="#39933f" content="done" inline></v-badge></span>
                    </div></div>
                  </div> -->
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
 // import AddCommentModal from '@/components/modals/addComment.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
// import { Toaster, toast } from 'vue-sonner'

import { toast } from 'vue-sonner'
import api from '@/tools/api';
import ProjectNameModal from '@/components/modals/projectNameModal.vue'
import exportFromJSON from "export-from-json";
export default {
  components: {
    ProjectNameModal
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      pageInfo: {
        mainTitle : "My dashboard space",
        subTitle : "Monitor progress and manage next steps",
      },
      seeAllStep : true,
      project: {},
      dialog: false,
      dailogSF: false,
      currentSearchField: {},
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
    sfModal: function(s){
      this.currentSearchField = s;
      this.dialogSF = true;
    },
    closeSFModal: function(){
      this.currentSearchField = {};
      this.dialogSF = false;
    },
    setNewSFtName(val){
      if(val){
        api.post(process.env.VUE_APP_API_URL+"/restrict/set_new_sf_name",
          {
              searchfield: this.currentSearchField._id.$oid,
              value: val
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("The search field name has been updated.");

          var csf = this.currentSearchField;
          console.log(csf);
            this.project.search_field.forEach((item) => {
                if(item._id.$oid == csf._id.$oid)item.name = val;
            });
            this.currentSearchField = {};
            this.dialogSF = false;
        //  this.project.name = val;
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
      }
      this.dialog = false;
    },
    setNewProjectName(val){
      if(val){
        api.post(process.env.VUE_APP_API_URL+"/restrict/set_new_project_name",
          {
              project: this.$route.params.id,
              value: val
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Your project name has been updated.");
          this.project.name = val;
        }).catch( (e) => {
        if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
        else toast.error("Sorry an error occurs !")
        });
      }
      this.dialog = false;
    },
    exportTry() {
         var data = [];
         const fileName =this.project.name;

        this.project.search_field.forEach((item) => {
          console.log(item);

          item.tasks.forEach((task) => {
            var tempo = {};
            var dd = "";
            if(task.date_done){
              const ddate = new Date(task.date_done.date)
              dd= new Intl.DateTimeFormat('en-US').format(ddate);
            }
            tempo["Project name"] = this.project.name;
            tempo["Search field"] = item.name;
            tempo["Action"] = task.task_name;
            tempo["Action status"] = task.status;
            tempo["Date of delivery"] = dd;
            data.push(tempo);
          });
          if(item.innopearl_tasks){
            item.innopearl_tasks.forEach((task) => {
              var tempo = {};
              tempo["Project name"]= this.project.name;
              tempo["Search field"] = item.name;
              tempo["Action"] = task.task_name;
              tempo["Action status"] = task.status;
              tempo["Date of delivery"] = task.date;
              tempo["Expected date"] = task.expected_date;
              data.push(tempo);
            });
          }


        });
        console.log(data);
         const exportType = exportFromJSON.types.csv;

         if (data) exportFromJSON({ data, fileName, exportType });
       },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     api.get(process.env.VUE_APP_API_URL+"/restrict/project/dashboard_V2/"+this.$route.params.id).then( (r) => {
       // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
        console.log(r.data);
       // var temp = _.merge(this.candidatespool, r.data)
       this.project = r.data;
       this.project.search_field.forEach((item) => {
         item.seeAllStep =true;
       });

       console.log(r);
     }).catch( (e) => {
       console.log(e);
        toast.error("Sorry an error occurs !")
   });
  }
}
</script>
<style scoped>
.project_space{
  padding-top:50px;
  padding-bottom: 50px;
}
 .project_searchfield_dash{
   background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
padding: 50px;
margin-top:50px;
margin-bottom: 50px;
 }
 .project_searchfield_dash .project_name{
   display:block;
   letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
font-size: 28px;
line-height:34px;
 }
.project_searchfield_dash .searchfield_name {
  letter-spacing: 0px;
color: #b38d2f;
text-transform: uppercase;
font-size: 14px;
line-height:22px;
font-weight:700;

 }
.project_searchfield_dash .actionsOnePro{
  margin-top:50px;
}

.action_title{
  letter-spacing: 0px;
color: #3783C5;
text-transform: none;
font-size:18px;
line-height: 21px;
margin-top:0px;
margin-bottom: 20px;
display: block;
font-weight: 600;
}
 .dotted_border_bottom{
   padding-bottom: 20px;
   border-bottom: 2px dotted #3783C5;
 }

 .action_list{
   display: flex;
   gap: 20px;
   margin-top:25px;
   font-size:15px;
   line-height:20px;
   text-transform: uppercase;
   background:#3783C51A;
   border-radius:200px;
   padding-left:25px;
   padding-right:25px;
   padding-top:15px;
   padding-bottom: 14px;
   justify-content: space-between;
   color:#3783C5;
   font-weight: 500;
   opacity: .5;
 }
 .action_list.done{
   opacity:1;
 }





   .switch {
  --circle-dim: 1.4em;
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 3.5em;
  height: 2em;
  margin-left: 10px;
  margin-right: 10px;

}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.pre_text,
.after_text{

font-size: 12px;
line-height:22px ;
letter-spacing: 0px;
color: #3783C5;
opacity: 1;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  transition: .4s;
  border-radius: 30px;
  border: 1px solid #3783C5;
}

.slider-card {
  position: absolute;
  content: "";
  height: var(--circle-dim);
  width: var(--circle-dim);
  left: 0.3em;
  bottom: 0.3em;
  transition: .4s;
  pointer-events: none;
}

.slider-card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  perspective: 1000px;
  border-radius: 50%;
  transition: .4s transform;
}

.slider-card-front {
  background-color: #3783C5;
}

.slider-card-back {
  background-color: #FFF;
  transform: rotateY(180deg);
}



 .switch input:checked ~ .slider-card {
  transform: translateX(1.5em);
}

 .switch input:checked ~ .slider {
  background-color: #fff;
}

.mt20{
  margin-top:20px;
}

.downloadBtn{
  background: #3783C5 0% 0% no-repeat padding-box;
border: 1px solid #3783C5;
padding: 10px 14px;
color:#FFF;
border-radius: 50px;
text-align: center;
margin: auto;
display: block;
font-size:12px;
line-height:15px;
}
.downloadBtn img{
  margin-left:0px;
  margin-right: 5px;
  width:25px;
  height:25px;
  object-fit:contain;
}
.action_list a{
  text-decoration: none;
  color: inherit;
}

@media screen and (max-width: 690px){
   .project_searchfield_dash{
     padding-left:15px;
     padding-right: 15px;
   }
}

.prev_step_btn{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    display:inline-block;
    margin:auto;
    width:auto;
}
.fondBlanc{
  background:#FFF;
}
.reopenProjectBTN{
  border:1px solid #842029;
  padding:5px 15px;
  border-radius:20px;
  display: inline-block;
  width: auto;
  margin: auto;
  margin-top:10px;
  color:#842029;
}
.closeProjectBTN{
  border:1px solid #3783C5;
  color:#FFF;
  background:#3783C5;
  padding:5px 15px;
  border-radius:20px;
  margin-top:10px;
}

.closedProjectInfo{
  margin-top:15px !important;
    color:#842029;
}

.mt50{
  margin-top:50px;
}

.action_list .name{
  width:100%;
}
.action_list .name a{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.action_list .name a img{
     transition: transform 330ms ease-in-out;
}
.action_list .name a:hover img{
transform:translateX(5px);
}

@media screen and (min-width:991px){
  .actionsOnePro > div:nth-child(1){
    border-right: .5px solid #D5AC48;
    padding-right:50px;
  }
  .actionsOnePro > div:nth-child(2){
    border-left: .5px solid #D5AC48;
    padding-left:50px;
  }
}

@media screen and (max-width:990px){

  .actionsOnePro > div:nth-child(2){
    padding-top:50px;
  }
}
</style>
